import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Wrapper from "../Wrappers/Wrapper";
import TurnstileWidget from "./TurnstileWidget";
import {FormContainer, StyledCheckbox, StyledRadio} from "./FormStyles";

const FamilyEveningRegistration = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const siteUrl = data.site.siteMetadata.siteUrl;

  return (
    <FormContainer>
      <Wrapper style={{ marginBottom: 50 }}>
        <h2>Anmeldung Angehörigenabend</h2>
        <p>Donnerstag, 5. Februar 2026, 19.00 Uhr</p> <br/>
        <form action={process.env.GATSBY_GOEASTFORM_FORM_ACTION} method="POST">
          <input type="hidden" name="subject" value="Anmeldung Angehörigenabend"/>
          <input type="hidden" name="recipient" value={process.env.GATSBY_GOEASTFORM_RECIPIENT || ''}/>
          <input type="hidden" name="redirect" value={`${siteUrl}/form-sent`}/>
          <input type="hidden" name="missing" value={`${siteUrl}/form-missing`}/>
          <input type="hidden" name="required" value="Bewohner"/>

          <div className="form-group">
            <div className="form-input">
              <label htmlFor="bewohnende">Name und Vorname Bewohner/in *</label>
              <input type="text" id="bewohnende" name="Bewohner" required/>
            </div>
          </div>

          <div className="form-group">
            <div style={{marginBottom: 15}}>Pflegewohnabteilung</div>
            <label><StyledRadio type="radio" name="PWA" value="PWA 1"/> PWA 1</label><br/>
            <label><StyledRadio type="radio" name="PWA" value="PWA 2"/> PWA 2</label><br/>
            <label><StyledRadio type="radio" name="PWA" value="PWA 3"/> PWA 3</label><br/>
            <label><StyledRadio type="radio" name="PWA" value="PWA 4"/> PWA 4</label>
          </div>

          <div className="form-input">
            <label htmlFor="gast1">Name und Vorname Gast 1:</label>
            <input type="text" id="gast1" name="Gast_1"/>
          </div>

          <div className="form-input">
            <label htmlFor="gast2">Name und Vorname Gast 2:</label>
            <input type="text" id="gast2" name="Gast_2"/>
          </div>

          <div className="form-input">
            <label htmlFor="gast3">Name und Vorname Gast 3:</label>
            <input type="text" id="gast3" name="Gast_3"/>
          </div>

          <TurnstileWidget siteKey={process.env.GATSBY_GOEASTFORM_TURNSTILE_SITE_KEY || ''}/>

          <button type="submit">Absenden</button>
        </form>
      </Wrapper>
    </FormContainer>
  );
};

export default FamilyEveningRegistration;